module.exports = __webpack_public_path__ + "static/media/undraw_no_data_qbuo.f6ad4e8b.svg";